/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { ActiveIncomingCall } from "./ActiveIncomingCall";
import {
  ActiveIncomingCallFromJSON,
  ActiveIncomingCallFromJSONTyped,
  ActiveIncomingCallToJSON,
  ActiveIncomingCallToJSONTyped,
} from "./ActiveIncomingCall";

/**
 *
 * @export
 * @interface ActiveIncomingCallResponse
 */
export interface ActiveIncomingCallResponse {
  /**
   *
   * @type {ActiveIncomingCall}
   * @memberof ActiveIncomingCallResponse
   */
  activeCall?: ActiveIncomingCall | null;
}

/**
 * Check if a given object implements the ActiveIncomingCallResponse interface.
 */
export function instanceOfActiveIncomingCallResponse(
  value: object,
): value is ActiveIncomingCallResponse {
  return true;
}

export function ActiveIncomingCallResponseFromJSON(
  json: any,
): ActiveIncomingCallResponse {
  return ActiveIncomingCallResponseFromJSONTyped(json, false);
}

export function ActiveIncomingCallResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ActiveIncomingCallResponse {
  if (json == null) {
    return json;
  }
  return {
    activeCall:
      json["activeCall"] == null
        ? undefined
        : ActiveIncomingCallFromJSON(json["activeCall"]),
  };
}

export function ActiveIncomingCallResponseToJSON(
  json: any,
): ActiveIncomingCallResponse {
  return ActiveIncomingCallResponseToJSONTyped(json, false);
}

export function ActiveIncomingCallResponseToJSONTyped(
  value?: ActiveIncomingCallResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    activeCall: ActiveIncomingCallToJSON(value["activeCall"]),
  };
}
